import AuthAPI from '@/services/authAPI'

export const userService = {
  login,
  logout,
}

async function login(email, password) {

  const response = await AuthAPI.login(email, password)
  return response

}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
  localStorage.removeItem('info')
}

